export default __webpack_public_path__ + "62a8802f80caf09085def61dfb302ec6.svg";